import { Link } from "react-router-dom";
import AppButton from "../components/ui/AppButton";

export default function AccessDenied() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-4">
      <div className="max-w-md w-full text-center bg-milk border border-border rounded-xl p-8 shadow-sm">
        <div className="text-5xl text-amber-brand">✿</div>
        <h2 className="font-display text-2xl text-cocoa mt-3">Access restricted</h2>
        <p className="text-sm text-mahogany mt-2">
          You don&apos;t have permission to view this page. Contact your admin if you
          believe this is a mistake.
        </p>
        <div className="mt-6">
          <Link to="/">
            <AppButton label="Back to Dashboard" />
          </Link>
        </div>
      </div>
    </div>
  );
}
